/**
 * Per-job EVM view personalization (filters, slicer sizes and spots, tabs,
 * calendars, staffing controls). One JSON blob per job in localStorage, so
 * every browser profile (= user) keeps its own layout per project.
 *
 * The old global keys (evm-earned-source-v1, evm-slicer-layout-v2, …) still
 * seed the defaults for a job the user has never opened; from the first visit
 * on, this blob wins for that job.
 */

const KEY_PREFIX = 'evm-job-view-v1:';

function key(jobNumber) {
  return `${KEY_PREFIX}${String(jobNumber || '').trim()}`;
}

export function loadJobViewPrefs(jobNumber) {
  if (!String(jobNumber || '').trim()) return null;
  try {
    const raw = localStorage.getItem(key(jobNumber));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function saveJobViewPrefs(jobNumber, prefs) {
  if (!String(jobNumber || '').trim()) return;
  try {
    localStorage.setItem(key(jobNumber), JSON.stringify({ ...prefs, _savedAt: Date.now() }));
  } catch {
    /* storage full / private mode — view prefs are best-effort */
  }
}
